export default function (prefix = '') {
    return `${prefix}${Math.random().toString(16).substring(2, 8)}`;
}
